import { takeLatest } from 'redux-saga'
import { put, select, call, all, take } from 'redux-saga/effects'

import actionTypes from 'redux/actions/actionTypes'
import callAny from './helpers/call_any'
import onboardingActivityActions from 'redux/actions/onboardingActivityActions'
import generalActions from 'redux/actions/generalActions'
import formatError from './helpers/error_formatter'
import onboardingActivitySync from 'sync/onboarding_activity_sync'
import userSync from 'sync/user_sync'
import onboardingActivityDataSelector from 'redux/selectors/onboarding_activity/onboarding_activity_data_selector'
import notificationTypes from 'helpers/enums/notificationTypes'
import actionUserTypes from 'helpers/enums/actionUserTypes'

function *createLesson() {
	try {
		const lessonData = yield select(onboardingActivityDataSelector)
		if (lessonData.lessonId === '') {
			const lessonDataResponse = yield callAny(onboardingActivitySync.createLesson)
			yield put(onboardingActivityActions.createLessonSuccess(lessonDataResponse.payload))
		}
	} catch (error) {
		const serverError = formatError(error)
		yield put(onboardingActivityActions.createLessonFailed(serverError))
	}
}

function *completeFirstLesson(action) {
	try {
		const lessonData = yield select(onboardingActivityDataSelector)
		//
		const token = lessonData.jwt
		const slideId = lessonData.customSlideId
		const parentId = lessonData.parentCustomSlideId
		const topic = action.topic
		yield all( [
			callAny(onboardingActivitySync.enableFirstLesson, lessonData.lessonId),
			callAny(onboardingActivitySync.updateBoard, token, slideId, parentId, topic),
			take(actionTypes.ONBOARDING_ACTIVITY_TRANSITION_ANIMATION_COMPLETED),
		])
		//
		yield put(onboardingActivityActions.addActivitySuccess())
	} catch (error) {
		const serverError = formatError(error)
		yield put(onboardingActivityActions.addActivityFailed(serverError))
	}
}

function *loadAsset() {
	yield call(onboardingActivitySync.loadAsset)
}

function *onboardingStatusUpdate(action) {
	let actionUser = actionUserTypes.ACTION_CANCEL
	if (action.type === actionTypes.ONBOARDING_ACTIVITY_ADD_ACTIVITY_SUCCESS) {
		actionUser = actionUserTypes.ACTION_CONTINUE
	}
	try {
		yield callAny(userSync.loginNotification,
			notificationTypes.ONBOARDING_ACTIVITY_STATUS_NOTIFICATION,
			null,
			actionUser
		)
	} catch (error) {
		yield put(generalActions.syncUncaughtError(error))
	}
}

export default [
	takeLatest([
		actionTypes.ONBOARDING_ACTIVITY_EXPLAINER_INITIALIZE,
		actionTypes.ONBOARDING_ACTIVITY_CREATE_INITIALIZE,
	], createLesson),
	takeLatest(actionTypes.ONBOARDING_ACTIVITY_ADD_ACTIVITY, completeFirstLesson),
	takeLatest(actionTypes.ONBOARDING_ACTIVITY_CREATE_INITIALIZE, loadAsset),
	takeLatest([
		actionTypes.ONBOARDING_ACTIVITY_ADD_ACTIVITY_SUCCESS,
		actionTypes.ONBOARDING_ACTIVITY_ADD_ACTIVITY_CANCELLED,
	], onboardingStatusUpdate),
]

export {
	createLesson,
	completeFirstLesson,
	loadAsset,
	onboardingStatusUpdate,
}
